import noScroll from "@/utils/noScroll.js";

export default function (element, data) {
  const closeButton = element.querySelector(".close");
  const menu = element.querySelector(".popup-menu");
  const links = element.querySelectorAll("a");

  window.addEventListener("open_menu", function () {
    element.classList.add("open");
    noScroll.hideScroll();
  });

  function close() {
    element.classList.remove("open");
    noScroll.showScroll();
  }

  menu.addEventListener("click", function (event) {
    event.stopPropagation();
  });

  element.addEventListener("click", close);
  closeButton.addEventListener("click", close);

  links.forEach(function (link) {
    link.addEventListener("click", close);
  });
}
